var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: { title: "Widgets Center", width: "900px", footer: null },
      on: { cancel: _vm.closeModal },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "widgets-center" }, [
        _c("div", { staticClass: "categories" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("chatbotv2.categories")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "category-list" }, [
            _c("li", { staticClass: "category-item active" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v(_vm._s(_vm.$t("tables.suggested"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Güncel Kalma"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Motivasyon"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("Medya")]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("Kişisel")]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Supsis Uygulamaları"),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "category-item d-none" }, [
              _c("a", { attrs: { href: "javascript:;" } }, [
                _vm._v("Marketplace Uygulamaları"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "widgets-container" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("tables.suggested")))]),
          _vm._v(" "),
          _c("div", { staticClass: "widgets-grid" }, [
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/chart.png",
                      alt: _vm.$t("tables.graph"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.graph"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.graphDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("chart")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/numbers.png",
                      alt: _vm.$t("tables.numbers"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.numbers"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.numbersDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("numbers")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/text.png",
                      alt: _vm.$t("message.text"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.text"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.textDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("text")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/countdown.png",
                      alt: "Geri Sayım Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v(_vm._s(_vm.$t("tables.countdown"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.countdownDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("countdown")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/iframe.png",
                      alt: "Iframe Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("Iframe")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.iframeDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("iframe")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/youtube.png",
                      alt: "YouTube Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [_vm._v("YouTube")]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(_vm._s(_vm.$t("tables.youtubeDesc"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("youtube")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/gantt.png",
                      alt: "Gantt Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v("Gantt Chart"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(
                    "Görevlerinizi ve projenizi zaman çizelgesi üzerinde görselleştirin"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("gantt")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "widget-card" },
              [
                _c("div", { staticClass: "widget-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/tables/pivot.svg",
                      alt: "Pivot Widget",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "widget-title" }, [
                  _vm._v("Pivot Table"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "widget-description" }, [
                  _vm._v(
                    "Verilerinizi dinamik pivot tablosu ile analiz edin ve özetleyin"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-widget-btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.selectWidgetType("pivot")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tables.addWidget")))]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }